import type { LucideIcon } from 'lucide-react';

/**
 * Card de metrica sobrio, sem gradientes nem blur.
 * Usa apenas border + tipografia pra definir hierarquia.
 */
interface StatCardProps {
    label: string;
    value: string;
    icon: LucideIcon;
    hint?: string;
    details?: Array<{ key: string; val: string }>;
}

export function StatCard({ label, value, icon: Icon, hint, details }: StatCardProps) {
    return (
        <div className="rounded-lg border border-gray-200 bg-white p-4 flex flex-col gap-3">
            <div className="flex items-center justify-between">
                <span className="text-[11px] font-semibold uppercase tracking-wide text-gray-500">
                    {label}
                </span>
                <Icon className="h-4 w-4 text-gray-400" />
            </div>
            <div>
                <p className="text-2xl font-bold text-gray-900 tabular-nums">{value}</p>
                {hint && <p className="text-[11px] text-gray-500 mt-0.5">{hint}</p>}
            </div>
            {details && details.length > 0 && (
                <div className="pt-3 border-t border-gray-100 space-y-1">
                    {details.map((d, i) => (
                        <div key={i} className="flex items-center justify-between text-xs">
                            <span className="text-gray-500">{d.key}</span>
                            <span className="font-semibold text-gray-700 tabular-nums">{d.val}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
